import React, { useState, useEffect } from 'react';
import upArrowIcon from "../assets/images/icons/up-arrow-icon.svg"

const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Show button when page is scrolled down
    const toggleVisibility = () => {
        let scrollableDiv = document.querySelector('.full-scroll-scroller')
        if (scrollableDiv?.scrollTop > 150) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    // Scroll the page to the top
    const scrollToTop = () => {
        let scrollableDiv = document.querySelector('.full-scroll-scroller')
        scrollableDiv?.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        let scrollableDiv = document.querySelector('.full-scroll-scroller')
        scrollableDiv?.addEventListener('scroll', toggleVisibility);
        return () => scrollableDiv?.removeEventListener('scroll', toggleVisibility);
    }, []);

    return (
        <div>
            {isVisible && (
                <div className='back-to-top-wrapper'>
                <div className='back-to-top-inner'>
                    <button 
                        onClick={scrollToTop}
                        aria-label="Scroll to top"
                    >
                        <img src={upArrowIcon} alt='arrow' />
                    </button>
                    <span>Back to Top</span>
                </div>
            </div>
            )}
        </div>
    );
};

export default ScrollToTop;